import React from "react";
import { ArrowRight, CircleCheck, Globe, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScaleWithoutBorders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="9782" id="bridging-enterprise-wisdom-with-ai-innovation" ref={ref} className="relative w-full overflow-hidden bg-background py-20 lg:py-32">
      {}
      <div className="pointer-events-none absolute -top-24 -left-24 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />
      <div className="pointer-events-none absolute top-1/2 right-0 h-64 w-64 -translate-y-1/2 rounded-full bg-slate-200/50 blur-3xl dark:bg-slate-900/20" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-20">
          {}
          <div className={`flex flex-col gap-8 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <div className="space-y-4">
              <Badge variant="outline" className="w-fit border-secondary/20 bg-secondary/5 px-3 py-1 text-sm font-medium text-secondary backdrop-blur-sm">We build the tools your best employee used to do — only faster, cheaper, and they never call in sick.</Badge>
              <h1 className="font-sans text-5xl font-bold tracking-tighter text-primary md:text-6xl lg:text-7xl lg:leading-[1.1]">Bridging Enterprise Experience with&nbsp;<span className="bg-gradient-to-r from-secondary to-blue-400 bg-clip-text text-transparent" data-ast-id="f:/src/pages/Home/sections/ScaleWithoutBorders.tsx|sig:7jpyty" data-ast-start="1802" data-ast-end="2106" contenteditable="false">Focused Execution.</span></h1>
              <p className="max-w-xl text-lg text-muted-foreground md:text-xl leading-relaxed">Harness decades of elite consulting legacy to transform your organizational processes. Automated quoting, dispatch, and back-office tools for small manufacturers and service contractors. Built in days. Paid for in weeks.</p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Link to="/ContactPage">
                <Button size="lg" className="group h-14 px-8 text-base bg-secondary hover:bg-secondary/90 text-white shadow-lg shadow-secondary/25 transition-all hover:scale-105">
                  Schedule a Consultation
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="/OurStoryPage">
                <Button variant="outline" size="lg" className="h-14 px-8 text-base border-slate-200 text-primary hover:bg-slate-50">
                  View Our Legacy
                </Button>
              </Link>
            </div>

            <div className="mt-4 flex items-center gap-6 text-sm font-semibold text-slate-500">
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span>Proven Complex Project Integration Delivery</span>
              </div>
              <div className="flex items-center gap-2">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span>Business Outcome Focused</span>
              </div>
            </div>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-lg lg:max-w-none transition-all duration-1000 delay-200 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            {}
            <div className="relative aspect-[4/3] overflow-hidden rounded-2xl shadow-2xl shadow-primary/5 lg:aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/focuspath_executive_strategy_session.png" alt="Business leader reviewing AI-driven strategy" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent" />
            </div>

            {}
            

            {}
            
          </div>
        </div>
      </div>
    </section>;
}